<script lang="ts">
	import type { Category } from "@core/schema/Category.js";
	import { getCataloguePath } from "@core/schema/paths/getCataloguePath.js";
	import image from "../assets/photos/image.png?webp&w=569&imagetools";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import ContactForm from "./ContactForm.svelte";
	import translations from "./ProductsPage.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	export let categories: Category[];

	const translate = getTranslate(translations);

	const { tenant } = getGlobalTemplateProps();

	const catalogueCategory = {
		id: "catalogue",
		nameForListing: translate("catalogueName"),
		image,
		descriptionForListing: translate("catalogueDescription"),
		urlSlug: getCataloguePath(tenant.locale),
	};

	const listingCategories = [catalogueCategory, ...categories];
</script>

{#each listingCategories as category, index (category.id)}
	<section class="full-width grid-container {index % 2 === 0 ? '' : 'bg-zms-grey'} py-10 md:py-[5.5rem]">
		<div class="container-center flex items-center flex-col gap-11 lg:gap-[5.5rem]">
			<div
				class="flex flex-col-reverse lg:flex-row lg:justify-between lg:items-center gap-8 lg:gap-[8.25rem] w-full {index %
					2 ===
				0
					? ''
					: 'lg:flex-row-reverse'}"
			>
				<Media
					wrapperClass="lg:w-[32rem] h-[16rem] lg:h-[32rem]"
					class="rounded-2xl object-cover w-full h-full"
					height={512}
					width={512}
					alt={category.nameForListing}
					source={typeof category.image === "string" ? { src: category.image, type: "image/webp" } : category.image}
				/>
				<div class="flex flex-col lg:w-[32rem] gap-8 lg:gap-10 {index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}">
					<h2><Formatted text={category.nameForListing} /></h2>
					<p class="font-normal lg:text-lg/[1.4] text-optical-black">
						<Formatted text={category.descriptionForListing} />
					</p>
					<div class="lg:block hidden mt-6">
						<Link href={category.urlSlug} variant={ButtonVariant.OutlinedWithIcon}
							><TextWithIcon>{translate("moreInfo")}</TextWithIcon></Link
						>
					</div>
				</div>
			</div>
			<div class="lg:hidden">
				<Link href={category.urlSlug} variant={ButtonVariant.OutlinedWithIcon}
					><TextWithIcon>{translate("moreInfo")}</TextWithIcon></Link
				>
			</div>
		</div>
	</section>
{/each}

<ContactForm heading="default" />
